import { ID_PATTERN } from '../constants/services';

export const getUrlForId = ( url: string, id: number ) => url.replace( ID_PATTERN, `${id}` );
